import React from 'react';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route } from 'react-router-dom';

import ROUTES from 'routes/index';
import AuthLayout from 'layouts/AuthLayout';
import PrivateLayout from 'layouts/PrivateLayout';
import PublicLayout from 'layouts/PublicLayout';
import {
    LazyAboutPage,
    LazyAdsensePage,
    LazyAlbum,
    LazyAlbumList,
    LazyAlbumPhotoModal,
    LazyAlertsPage,
    LazyBookmarksPage,
    LazyEditProfilePage,
    LazyEmailVerificationPage,
    LazyFriendsPage,
    LazyGroupPage,
    LazyHomePage,
    LazyJoinPage,
    LazyLoginPage,
    LazyMessagesPage,
    LazyModListPage,
    LazyModLogPage,
    LazyModRecentContentPage,
    LazyModReportsPage,
    LazyModSettingsPage,
    LazyModSingleUserPage,
    LazyModUserSearchPage,
    LazyOauthCallbackPage,
    LazyOnboardingPage,
    LazyPostPhotoModal,
    LazyPrivacyPage,
    LazyProfilePage,
    LazyProfileUsernameRedirect,
    LazyPubstreamPage,
    LazyRecentPhotoModal,
    LazyResetPasswordPage,
    LazySearchGroupsPage,
    LazySearchPeoplePage,
    LazySettingsPage,
    LazySinglePostPage,
    LazySupportPage,
    LazyTosPage,
} from 'App/screens';
import ErrorPage from 'pages/ErrorPage';
import App from 'App';

const router = createBrowserRouter(
    createRoutesFromElements(
        <Route element={<App />}>
            <Route element={<PrivateLayout />}>
                <Route path={ROUTES.LANDING} element={<Navigate to={ROUTES.HOME} replace />} />
                <Route path={ROUTES.BOOKMARKS} element={<LazyBookmarksPage />} />
                <Route path={ROUTES.SETTINGS} element={<LazySettingsPage />} />
                <Route path={ROUTES.SEARCH_PEOPLE} element={<LazySearchPeoplePage />} />
                <Route path={ROUTES.SEARCH_GROUPS} element={<LazySearchGroupsPage />} />
                <Route path={ROUTES.GROUP} element={<LazyGroupPage />}>
                    <Route path={ROUTES.GROUP_POST_PHOTO} element={<LazyPostPhotoModal />} />
                </Route>
                <Route path={ROUTES.FRIENDS} element={<LazyFriendsPage />} />
                <Route path={ROUTES.EDIT_PROFILE} element={<LazyEditProfilePage section="info" />} />
                <Route path={ROUTES.EDIT_PROFILE_INTERESTS} element={<LazyEditProfilePage section="interests" />} />
                <Route path={ROUTES.EDIT_PROFILE_WANT_TO_MEET} element={<LazyEditProfilePage section="matching" />} />
                <Route path={ROUTES.POST} element={<LazySinglePostPage />}>
                    <Route path={ROUTES.POST_PHOTO} element={<LazyPostPhotoModal />} />
                </Route>
                <Route path={ROUTES.HOME} element={<LazyHomePage />}>
                    <Route path={ROUTES.HOME_POST_PHOTO} element={<LazyPostPhotoModal />} />
                </Route>
                <Route path={ROUTES.ALERTS} element={<LazyAlertsPage />} />
                <Route path={ROUTES.USER_PROFILE_UID} element={<LazyProfileUsernameRedirect />} />
                <Route path={ROUTES.USER_PROFILE} element={<LazyProfilePage />}>
                    <Route path={ROUTES.USER_PROFILE_POST_PHOTO} element={<LazyPostPhotoModal />} />
                    <Route path={ROUTES.USER_PROFILE_CAROUSEL_PHOTO} element={<LazyAlbumPhotoModal />} />
                    <Route path={ROUTES.USER_PROFILE_RECENT_PHOTO} element={<LazyRecentPhotoModal />} />
                    <Route path={ROUTES.USER_PROFILE_ALBUM_LIST} element={<LazyAlbumList />} />
                    <Route path={ROUTES.USER_PROFILE_ALBUM_LIST_RECENT_PHOTO} element={<LazyRecentPhotoModal />} />
                    <Route path={ROUTES.USER_PROFILE_ALBUM} element={<LazyAlbum />} />
                    <Route path={ROUTES.USER_PROFILE_ALBUM_PHOTO} element={<LazyAlbumPhotoModal />} />
                </Route>
            </Route>
            <Route element={<PrivateLayout isModeration={true} />}>
                <Route path={ROUTES.MODERATION_REPORTS} element={<LazyModReportsPage />} />
                <Route path={ROUTES.MODERATION_LIST} element={<LazyModListPage />} />
                <Route path={ROUTES.MODERATION_USER} element={<LazyModSingleUserPage />} />
                <Route path={ROUTES.MODERATION_LOG} element={<LazyModLogPage />} />
                <Route path={ROUTES.MODERATION_RECENT} element={<LazyModRecentContentPage />} />
                <Route path={ROUTES.MODERATION_USER_SEARCH} element={<LazyModUserSearchPage />} />
                <Route path={ROUTES.MODERATION_SETTINGS} element={<LazyModSettingsPage />} />
            </Route>
            <Route element={<PrivateLayout isFullHeight={true} />}>
                <Route path={ROUTES.MESSAGES_THREAD} element={<LazyMessagesPage />} />
                <Route path={ROUTES.MESSAGES_HOME} element={<LazyMessagesPage />} />
                <Route path={ROUTES.MODERATION_MESSAGES} element={<LazyMessagesPage />} />
                <Route path={ROUTES.MODERATION_MESSAGE_THREAD} element={<LazyMessagesPage />} />
            </Route>
            <Route element={<AuthLayout />}>
                <Route path={ROUTES.LOGIN} element={<LazyLoginPage />} />
                <Route path={ROUTES.OAUTH_CALLBACK} element={<LazyOauthCallbackPage />} />
                <Route path={ROUTES.ONBOARDING} element={<LazyOnboardingPage />} />
                <Route path={ROUTES.JOIN} element={<LazyJoinPage />} />
                <Route path={ROUTES.EMAIL_VERIFICATION} element={<LazyEmailVerificationPage />} />
                <Route path={ROUTES.RESET_PASSWORD} element={<LazyResetPasswordPage />} />
            </Route>
            <Route element={<PublicLayout />}>
                <Route path={ROUTES.ABOUT} element={<LazyAboutPage />} />
                <Route path={ROUTES.SUPPORT} element={<LazySupportPage />} />
                <Route path={ROUTES.PRIVACY} element={<LazyPrivacyPage />} />
                <Route path={ROUTES.TOS} element={<LazyTosPage />} />
                <Route path={ROUTES.AD_TEST_ADSENSE} element={<LazyAdsensePage />} />
                <Route path={ROUTES.AD_TEST_PUBSTREAM} element={<LazyPubstreamPage />} />
                <Route path="*" element={<ErrorPage type={404} />} />
            </Route>
            <Route path="*" element={<ErrorPage type={404} />} />
        </Route>,
    ),
);

export default router;
